import { buttonProps } from './button2.mjs';

const buttonGroupProps = {
  size: buttonProps.size,
  type: buttonProps.type
};

export { buttonGroupProps };
//# sourceMappingURL=button-group.mjs.map
